export enum TaskDueDateStatus {
  'AHEAD' = 'AHEAD',
  'DUE_TOMORROW' = 'DUE_TOMORROW',
  'DUE_TODAY' = 'DUE_TODAY',
  'OVERDUE' = 'OVERDUE',
}

export enum TaskDueDateStatusClass {
  'AHEAD' = 'bg-light-dark text-dark',
  'DUE_TOMORROW' = 'bg-light-info text-info',
  'DUE_TODAY' = 'bg-light-warning text-warning',
  'OVERDUE' = 'bg-danger text-white',
}
